<template>
  <b-overlay :show="show" rounded="sm" @shown="onShown" @hidden="onHidden">
    <div class="form-container">
      <div class="wrapper">
        <div>
          <b-row>
            <b-col>
              <b-form-group
                label="Log Number"
                label-size="sm"
                label-class="font-weight-bold"
                disabled
              >
                <b-form-input autocapitalize="off" v-model="detail.log_number" />
              </b-form-group>
              <b-form-group
                label="Contractor Name"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="contractories.name"
                  disabled
                />
              </b-form-group>
              <b-form-group
                label="Contract Number"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="contractories.contract_number"
                  disabled
                />
              </b-form-group>
              <b-form-group
                label="Order Number"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="workOrder.wo_number"
                  disabled
                />
              </b-form-group>
              <b-form-group
                label="Budget Code"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="detail.budget_code"
                  disabled
                />
              </b-form-group>
              <b-form-group
                label="Department"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="workOrder.department_name"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Date"
                    label-size="sm"
                    label-class="font-weight-bold"
                  >
                    <b-row>
                      <b-form-input
                        id="input-log-date"
                        class="input-log-date"
                        :value="formatDate(detail.log_date)"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        disabled
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="detail.log_date"
                          button-only
                          left
                          locale="en-US"
                          aria-controls="input-log-date"
                          size="sm"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="Shift"
                    label-size="sm"
                    label-class="font-weight-bold"
                  >
                    <b-form-select
                      v-model="detail.shift"
                      :options="shifts"
                      value-field="id"
                      text-field="name"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group
                label="Unit Type"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-select
                  v-model="equipment_id"
                  :options="equipments"
                  value-field="id"
                  text-field="name"
                  size="sm"
                  @change="onUnitChange"
                />
              </b-form-group>
              <b-form-group
                label="Unit ID"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-select
                  v-model="unit_id"
                  :options="units"
                  value-field="id"
                  text-field="name"
                  size="sm"
                />
              </b-form-group>
              <b-form-group
                label="Job Desc"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input autocapitalize="off" v-model="detail.job_desc" />
              </b-form-group>
              <b-form-group
                label="Operator"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input autocapitalize="off" v-model="detail.operator" />
              </b-form-group>
              <b-form-group
                label="Supervisor"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="supervisorUser.username"
                  list="my-list-id"
                  placeholder="Enter Supervisor"
                  @keydown="onkeydown($event)"
                />
                <datalist id="my-list-id">
                  <option
                    v-for="(supervisor, index) in supervisors"
                    v-bind:key="index"
                  >
                    {{ supervisor.name }}
                  </option>
                </datalist>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="mt-4">
          <b-row>
            <b-col>
              <p>HM Start</p>
              <div class="dropbox_e">
                <input
                  type="file"
                  accept="image/*"
                  name="hm_start_image"
                  @change="onHMStartChange"
                  class="input-file_e"
                />
                <div id="preview" class="mt-2">
                  <img v-if="hm_start_preview" :src="hm_start_preview" />
                  <img v-else-if="detail.hm_start_image" :src="detail.hm_start_image" />
                  <img v-else src="@/assets/icon-upload-image.png" />
                </div>
                <p>
                  {{
                    detail.hm_start_image ? "" : "Drag or click button to upload photo"
                  }}
                </p>
                <b-button
                  class="btn-custom"
                  variant="info"
                  size="sm"
                  @click="isUpload = true"
                >
                  {{ detail.hm_start_image ? 'Change File' : 'Browse File' }}
                </b-button>
              </div>
            </b-col>
            <b-col>
              <p>HM Stop</p>
              <div class="dropbox_e">
                <input
                  type="file"
                  accept="image/*"
                  name="hm_finish_image"
                  @change="onHMFinishChange"
                  class="input-file_e"
                />
                <div id="preview" class="mt-2">
                  <img v-if="hm_finish_preview" :src="hm_finish_preview" />
                  <img v-else-if="detail.hm_finish_image" :src="detail.hm_finish_image" />
                  <img v-else src="@/assets/icon-upload-image.png" />
                </div>
                <p>
                  {{
                    detail.hm_finish_image ? "" : "Drag or click button to upload photo"
                  }}
                </p>
                <b-button
                  class="btn-custom"
                  variant="info"
                  size="sm"
                  @click="isUpload = true"
                >
                  {{ detail.hm_finish_image ? 'Change File' : 'Browse File' }}
                </b-button>
              </div>
            </b-col>
            <b-col>
              <p>Photo Job</p>
              <div class="dropbox_e">
                <input
                  type="file"
                  accept="image/*"
                  name="job_image"
                  @change="onJobChange"
                  class="input-file_e"
                />
                <div id="preview" class="mt-2">
                  <img v-if="job_preview" :src="job_preview" />
                  <img v-else-if="detail.job_image" :src="detail.job_image" />
                  <img v-else src="@/assets/icon-upload-image.png" />
                </div>
                <p>
                  {{ detail.job_image ? "" : "Drag or click button to upload photo" }}
                </p>
                <b-button
                  class="btn-custom"
                  variant="info"
                  size="sm"
                  @click="isUpload = true"
                >
                  {{ detail.hm_finish_image ? 'Change File' : 'Browse File' }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <table class="table-detail mt-4">
        <tr>
          <th class="th-detail" colspan="2">START</th>
          <th class="th-detail">REST</th>
          <th class="th-detail" colspan="2">FINISH</th>
          <th class="th-detail">DELAY</th>
          <th class="th-detail">WORKING</th>
        </tr>
        <tr>
          <td class="td-detail">
            <b-form-input
              autocapitalize="off"
              v-model="detail.hm_start"
              size="sm"
              type="number"
              autocomplete="off"
              step="0.1"
              rules="required"
              @input="checkHMStart"
            />
          </td>
          <td class="td-detail">
            <b-form-input
              type="time"
              v-model="detail.wt_start"
              rules="required"
            />
          </td>
          <td class="td-detail">
            <b-form-input
              type="time"
              v-model="detail.wt_rest"
              rules="required"
            />
          </td>
          <td class="td-detail">
            <b-form-input
              autocapitalize="off"
              v-model="detail.hm_finish"
              size="sm"
              type="number"
              autocomplete="off"
              step="0.1"
              rules="required"
              @input="checkHMFinish"
            />
          </td>
          <td class="td-detail">
            <b-form-input
              type="time"
              v-model="detail.wt_finish"
              rules="required"
            />
          </td>
          <td class="td-detail">
            {{ total_delay }}
          </td>
          <td class="td-detail">
            {{
              `${getTotalWorkingHourHM(
                detail.hm_start,
                detail.hm_finish
              )}`
            }} |
            {{
              `${getTotalWorkingHourWT(detail.wt_start, detail.wt_finish, detail.delay_breakdown, detail.delay_standby, detail.delay_technical)}`
            }}
          </td>
        </tr>
      </table>

      <div class="mt-1" style="color: red">
        <p v-if="isHMStartNotValid">
          Value HM Start must be greater than {{this.hmFinishBefore}}
        </p>
        <p v-if="isHMFinishNotValid">
          Value HM Finish must be lower than {{this.hmStartAfter}}
        </p>
      </div>

      <div class="d-flex mt-5">
        <b-button
          class="btn-default mr-auto"
          variant="danger"
          size="sm"
          @click="onClickClose"
        >
          Close
        </b-button>
        <b-button
          class="btn-reset mr-2"
          variant="outline-info"
          size="sm"
          @click="onClickCancel"
        >
          Cancel
        </b-button>
        <b-button
          v-if="detail.status === 'Draft'"
          class="btn-custom mr-2"
          variant="info"
          size="sm"
          @click="saveLogsheet"
          :disabled="onSubmitProgress"
          >
          Save as Draft
        </b-button>
        <b-button
          class="btn-custom"
          variant="info"
          size="sm"
          @click="submitLogsheet"
          :disabled="onSubmitProgress"
        >
          Submit
        </b-button>
      </div>
      <modal-approve :form="detail" :text="text" />
      <modal-successful :text="text" />
    </div>
    <template #overlay>
      <div class="text-center" style="min-width: 1000px">
        <div>
          <b-spinner variant="info" label="Spinning"></b-spinner>
        </div>
        <p class="mt-2">Please wait...</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
/* eslint-disable camelcase */
import api from '@/api'
import moment from 'moment'
import ModalApprove from '@/partials/ModalApprove'
import ModalSuccessful from '@/partials/ModalSuccessful'

export default {
  components: {
    ModalApprove,
    ModalSuccessful
  },

  data: () => ({
    onSubmitProgress: false,
    show: false,
    image: {
      hm_start_image: null,
      hm_finish_image: null,
      job_image: null
    },
    detail: {},
    form: {
      is_draft: false,
      is_submit: false,
      hm_start: '',
      hm_finish: '',
      wt_start: '',
      wt_finish: '',
      wt_rest: '',
      delay_breakdown: '',
      delay_standby: '',
      delay_technical: '',
      working_hour: '',
      working_hour_hm: '',
      log_number: '',
      wo_number: '',
      contractor_name: '',
      type_name: '',
      unit_name: '',
      log_date: '',
      shift: '',
      total_working_hours: '',
      working_type: '',
      status: '',
      job_desc: '',
      supervisor: null,
      hm_start_image: null,
      hm_finish_image: null,
      job_image: null
    },
    workOrder: {},
    contractories: {},
    text: '',
    file: '',
    equipment_id: null,
    change_type_id: null,
    type_id: null,
    unit_id: null,
    wo_id: null,
    equipments: [],
    units: [],
    supervisors: null,
    supervisorUser: {},
    shifts: [],
    isNewLogsheet: true,
    hm_start_image: null,
    hm_finish_image: null,
    job_image: null,
    hm_start_preview: null,
    hm_finish_preview: null,
    job_preview: null,
    base_hm_start_image: null,
    base_hm_fnish_image: null,
    base_job_image: null,
    total_delay: 0,
    hmStartAfter: null,
    hmFinishBefore: null,
    isHMStartNotValid: false,
    isHMFinishNotValid: false
  }),
  mounted() {
    this.fetctDetailLogsheet()
    this.fetchShifts()
    this.fetchSupervisors()
  },

  methods: {
    async saveLogsheet() {
      this.form.is_draft = true
      this.form.is_submit = false
      this.submitCommit()
    },
    async submitLogsheet() {
      this.form.is_draft = false
      this.form.is_submit = true
      this.submitCommit()
    },
    async submitCommit() {
      try {
        if (this.getTotalWorkingHourHM(this.detail.hm_start, this.detail.hm_finish) !== this.getTotalWorkingHourWT(this.detail.wt_start, this.detail.wt_finish, this.detail.delay_breakdown, this.detail.delay_standby, this.detail.delay_technical)) {
          this.$bvToast.toast('Hour meter and working time not match', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          return false
        }
        this.onSubmitProgress = true
        this.show = true
        const form = this.prepareForm()
        const fd = new FormData()
        fd.append('hm_start_image', this.hm_start_image)
        fd.append('hm_finish_image', this.hm_finish_image)
        fd.append('job_image', this.job_image)
        fd.append('content_body', JSON.stringify(form))
        await api.logsheet.update(this.$route.params.id, fd)
        this.text = 'edit log sheet'
        this.$bvModal.show('modal-successful')
        setTimeout(() => {
          this.$router.push('/log-sheet')
        }, 2000)
      } catch ({ response }) {
        this.onSubmitProgress = false
        this.show = false
        this.$nextTick(() => {
          if (response) {
            this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast('Error: Network Not Responded', {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            })
          }
        })
      }
    },
    prepareForm() {
      return {
        is_draft: this.form.is_draft,
        is_submit: this.form.is_submit,
        wo_id: this.wo_id,
        wo_equipment_id: this.equipment_id,
        log_number: this.detail.log_number,
        log_date: this.detail.log_date,
        shift: this.detail.shift,
        type_id: this.change_type_id,
        unit_id: this.unit_id,
        hm_start: this.detail.hm_start,
        hm_finish: this.detail.hm_finish,
        wt_start: this.detail.wt_start,
        wt_finish: this.detail.wt_finish,
        wt_rest: this.detail.wt_rest,
        working_hour: this.form.working_hour,
        operator: this.detail.operator,
        supervisor: this.supervisorUser.id ?? this.detail.supervisor,
        job_desc: this.detail.job_desc
      }
    },
    async fetctDetailLogsheet() {
      const data = await api.logsheet.get(this.$route.params.id)
      this.detail = data
      this.workOrder = this.detail.work_order_unit.workOrder
      this.contractories = this.detail.work_order_unit.workOrder.contractories
      this.equipment_id = this.detail.work_order_unit.equipment.id
      this.unit_id = this.detail.unit_id
      this.wo_id = this.detail.wo_id
      this.supervisorUser = this.detail.supervisorUser
      this.fetchEquipments(this.workOrder.contractor_id, this.wo_id)
      this.fetchUnits(this.equipment_id)
      this.hmStartAfter = this.detail.logsheetAfter[0] ? this.detail.logsheetAfter[0].hm_start : '00:00'
      this.hmFinishBefore = this.detail.logsheetBefore[0] ? this.detail.logsheetBefore[0].hm_finish : '00:00'
      this.checkHMStart(this.detail.hm_start)
      this.checkHMFinish(this.detail.hm_finish)
      if (this.detail.hm_start_image != null && this.detail.hm_finish_image != null && this.detail.job_image != null) {
        this.getBase64FromUrl(this.detail.hm_start_image).then((value) => {
          this.base_hm_start_image = value
        })
        this.getBase64FromUrl(this.detail.hm_finish_image).then((value) => {
          this.base_hm_finish_image = value
        })
        this.getBase64FromUrl(this.detail.job_image).then((value) => {
          this.base_job_image = value
        })
      }
      this.total_delay = Number(this.detail.delay_breakdown) + Number(this.detail.delay_standby) + Number(this.detail.delay_technical)
    },
    async fetchEquipments(contractor_id, wo_id) {
      this.equipments = await api.contractor.equipmentWo({ contractor_id, wo_id })
      this.change_type_id = this.equipments.find(i => i.id === this.equipment_id).type_id
    },
    async fetchUnits(value) {
      this.units = await api.contractor.unitId(value)
    },
    async fetchShifts() {
      this.shifts = await api.logsheet.shift()
    },
    async fetchSupervisors() {
      this.supervisors = await api.logsheet.supervisor(this.$route.params.id)
    },
    onHMStartChange(e) {
      const file = e.target.files[0]
      var check = file.name.split('.').pop()
      if (['jpg', 'jpeg', 'png'].includes(check.toLowerCase())) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        this.hm_start_preview = URL.createObjectURL(file)

        this.hm_start_image = file
      } else {
        e = ''
        this.$bvToast.toast('Only jpg/jpeg and png files are allowed!', {
          headerClass: 'd-none',
          solid: true,
          variant: 'danger'
        })
      }
    },
    onHMFinishChange(e) {
      const file = e.target.files[0]
      var check = file.name.split('.').pop()
      if (['jpg', 'jpeg', 'png'].includes(check.toLowerCase())) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        this.hm_finish_preview = URL.createObjectURL(file)

        this.hm_finish_image = file
      } else {
        e = ''
        this.$bvToast.toast('Only jpg/jpeg and png files are allowed!', {
          headerClass: 'd-none',
          solid: true,
          variant: 'danger'
        })
      }
    },
    onJobChange(e) {
      const file = e.target.files[0]
      var check = file.name.split('.').pop()
      if (['jpg', 'jpeg', 'png'].includes(check.toLowerCase())) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        this.job_preview = URL.createObjectURL(file)

        this.job_image = file
      } else {
        e = ''
        this.$bvToast.toast('Only jpg/jpeg and png files are allowed!', {
          headerClass: 'd-none',
          solid: true,
          variant: 'danger'
        })
      }
    },
    getTotalWorkingHourHM(start, finish) {
      if (start !== undefined) {
        if (Number(finish) > Number(start)) {
          this.form.working_hour = (Number(finish) - Number(start)).toFixed(2)
          return this.form.working_hour
        }
      }
      return 0
    },
    getTotalWorkingHourWT(start, finish, delayBreakdown, delayStandby, delayTechnical) {
      if (start !== undefined) {
        let working_hour = 0
        if (moment.utc(start, 'HH:mm') > moment.utc(finish, 'HH:mm')) {
          working_hour = moment.duration('24:00').subtract(start).add(finish).asMinutes()
        } else {
          working_hour = moment.duration(finish).subtract(start).asMinutes()
        }
        const delay = Math.round((Number(delayBreakdown) + Number(delayStandby) + Number(delayTechnical)) * 60)
        return ((working_hour - delay) / 60).toFixed(2)
      }
      return 0
    },
    onClickCancel() {
      this.$router.back()
    },
    onClickClose() {
      this.$router.push({ path: '/log-sheet' })
    },
    onPrint() {
      window.print()
    },
    onApprove() {
      this.text = 'Approve this work order'
      this.$bvModal.show('modal-approve')
    },
    onUnitChange() {
      const changeUnit = this.$emit('change', this.equipment_id)
      this.change_type_id = this.equipments.find(i => i.id === changeUnit.equipment_id).type_id
      this.equipment_id = changeUnit.equipment_id
      this.fetchUnits(changeUnit.equipment_id)
    },
    onkeydown(e) {
      const eventSource = e.key ? 'input' : 'list'
      this.sizeChangedBy = eventSource
    },
    async getBase64FromUrl(url) {
      const data = await fetch(url)
      const blob = await data.blob()
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
          const base64data = reader.result
          resolve(base64data)
        }
      })
    },
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY')
    },
    checkHMStart(value) {
      if (Number(value) < this.hmFinishBefore) {
        this.onSubmitProgress = true
        this.isHMStartNotValid = true
      } else {
        this.onSubmitProgress = false
        this.isHMStartNotValid = false
      }
    },
    checkHMFinish(value) {
      if (Number(value) > this.hmStartAfter) {
        this.onSubmitProgress = true
        this.isHMFinishNotValid = true
      } else {
        this.onSubmitProgress = false
        this.isHMFinishNotValid = false
      }
    },
    onShown() {},
    onHidden() {}
  },

  destroyed() {
    localStorage.removeItem('currentPage', this.currentPage)
    localStorage.removeItem('totalRows', this.totalRows)
  }
}
</script>

<style lang="scss">
.form-control {
  font-size: 12px;
}
.input-log-date {
  width: 80%;
  margin-left: 15px;
}
.col-form-label,
.col-form-label-sm {
  font-size: 12px !important;
}
.dropbox_e {
  border: 2px dashed #463191;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
  border-radius: 16px;
  text-align: center;
}
.input-file_e {
  margin-top: -12px;
  margin-left: -180px;
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox_e p {
  font-size: 12px;
  text-align: center;
  padding-top: 20px;
}
p {
  font-weight: bold;
}
.table-detail {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

.td-detail {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 5px;
}

.th-detail {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 5px;
}

.td-detail:nth-child(odd) {
  background-color: #dbf9f6;
}
.td-detail:nth-child(even) {
  background-color: #00b4a5;
}
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}
#preview img {
  max-width: 100%;
  max-height: 100px;
}
</style>
